import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import assert from 'assert'
import { db, FieldValue, Timestamp } from './firebase'
import { extend, getAdCounts, getFakeList, jumble, getRandomInt, getLikeCounts } from './utils'
import { POSTS, AD_POST_QUESTIONS, DEMO_QUESTIONS } from './AdData'

const AdDatabaseContext = createContext()

export function useAdDatabase() {
  return useContext(AdDatabaseContext)
}

export function AdDatabaseProvider({ children }) {

  const browser = useRef('not detected')
  const [posts, setPosts] = useState({})
  // const [users, setUsers] = useState(USERS)
  const [demoQuestions,] = useState(DEMO_QUESTIONS)
  const [adPostQuestions,] = useState(AD_POST_QUESTIONS)
  //const [politicsQuestions, ] = useState(POLITICS_QUESTIONS)
  //const [covidQuestions, ] = useState(COVID_QUESTIONS)
  // const countRef = useRef(['LL', 'LH', 'HL', 'HH', 'LH', 'HL', 'HH'])
  const [curUser, setCurUser] = useState(
    null
    // For Politics
    // {
    //   "name": "Dharmveer Bharti",
    //   "prolificId": "my_prolificId",
    //   "userCount": 5,
    //   "instanceVersion": 5,
    //   "friends": [
    //     {
    //       "name": "Subham Kumar"
    //     },
    //     {
    //       "name": "Rahul Kumar"
    //     },
    //     {
    //       "name": "Vikram"
    //     },
    //     {
    //       "name": "Vishal"
    //     },
    //     {
    //       "name": "Aman K."
    //     }
    //   ],
    //   "postsOrder": [
    //     3,
    //     4,
    //     1,
    //     6,
    //     5,
    //     2
    //   ],
    //   postsMetadata: {
    //     "1": {
    //         "authorData": {
    //             "index": 3,
    //             "name": "Vishal"
    //         },
    //         "initialLikeCount": 1857,
    //         "initialShareCount": 3,
    //         "friendData": {
    //             "name": "Aman K.",
    //             "index": 4,
    //             "type": "liked"
    //         }
    //     },
    //     "2": {
    //         "initialShareCount": 1839,
    //         "friendData": {
    //             "name": "Rahul Kumar",
    //             "index": 1,
    //             "type": "liked"
    //         },
    //         "initialLikeCount": 4,
    //         "authorData": {
    //             "index": 0,
    //             "name": "Subham Kumar"
    //         }
    //     },
    //     "3": {
    //         "initialLikeCount": 3,
    //         "authorData": {
    //             "index": 1,
    //             "name": "Rahul Kumar"
    //         },
    //         "initialShareCount": 1951,
    //         "friendData": {}
    //     },
    //     "4": {
    //         "authorData": {
    //             "name": "Vikram",
    //             "index": 5
    //         },
    //         "friendData": {
    //             "type": "liked",
    //             "name": "Rahul Kumar",
    //             "index": 1
    //         },
    //         "initialShareCount": 1917,
    //         "initialLikeCount": 1837
    //     },
    //     "5": {
    //         "friendData": {},
    //         "authorData": {
    //             "name": "Aman K.",
    //             "index": 4
    //         },
    //         "initialLikeCount": 1860,
    //         "initialShareCount": 3
    //     },
    //     "6": {
    //         "friendData": {
    //             "type": "liked",
    //             "index": 4,
    //             "name": "Aman K."
    //         },
    //         "initialShareCount": 5,
    //         "initialLikeCount": 4,
    //         "authorData": {
    //             "index": 2,
    //             "name": "Vikram"
    //         }
    //     }
    //   },
    // }
    // For Covid
    // {
    //   "friends": [
    //       {
    //           "name": "Dharm"
    //       },
    //       {
    //           "name": "Subham"
    //       },
    //       {
    //           "name": "Rahul K."
    //       },
    //       {
    //           "name": "Shivam"
    //       },
    //       {
    //           "name": "P. Raghav"
    //       }
    //   ],
    //   "prolificId": "my_prolificId2",
    //   "postsMetadata": {
    //       "7": {
    //           "authorData": {
    //               "index": 5,
    //               "name": "P. Raghav"
    //           },
    //           "friendData": {},
    //           "initialLikeCount": 5,
    //           "initialShareCount": 1800
    //       },
    //       "8": {
    //           "authorData": {
    //               "index": 1,
    //               "name": "Subham"
    //           },
    //           "initialShareCount": 4,
    //           "initialLikeCount": 3,
    //           "friendData": {}
    //       },
    //       "9": {
    //           "friendData": {
    //               "type": "liked",
    //               "index": 3,
    //               "name": "Shivam"
    //           },
    //           "authorData": {
    //               "index": 0,
    //               "name": "Dharm"
    //           },
    //           "initialLikeCount": 1953,
    //           "initialShareCount": 3
    //       },
    //       "10": {
    //           "initialShareCount": 3,
    //           "initialLikeCount": 3,
    //           "friendData": {
    //               "name": "Dharm",
    //               "index": 0,
    //               "type": "liked"
    //           },
    //           "authorData": {
    //               "index": 4,
    //               "name": "P. Raghav"
    //           }
    //       },
    //       "11": {
    //           "initialLikeCount": 5,
    //           "friendData": {
    //               "name": "Rahul K.",
    //               "type": "liked",
    //               "index": 2
    //           },
    //           "initialShareCount": 1954,
    //           "authorData": {
    //               "index": 3,
    //               "name": "Shivam"
    //           }
    //       },
    //       "12": {
    //           "initialLikeCount": 1906,
    //           "initialShareCount": 1979,
    //           "friendData": {
    //               "name": "Dharm",
    //               "type": "liked",
    //               "index": 0
    //           },
    //           "authorData": {
    //               "index": 2,
    //               "name": "Rahul K."
    //           }
    //       }
    //   },
    //   "userCount": 6,
    //   "name": "Dharmveer",
    //   "instanceVersion": 6,
    //   "postsOrder": [
    //       11,
    //       7,
    //       8,
    //       10,
    //       9,
    //       12
    //   ],
    // }
  )
  const [totalStates, setTotalStates] = useState(
    undefined
    // For Politics
    // 22
    // For Covid
    // 18
  )
  const [appState, setAppState] = useState(0)

  useEffect(() => {
    // Detect client's browser
    let userAgent = navigator.userAgent
    if (userAgent.match(/chrome|chromium|crios/i)) {
      browser.current = 'chrome'
    } else if (userAgent.match(/firefox|fxios/i)) {
      browser.current = 'firefox'
    } else if (userAgent.match(/safari/i)) {
      browser.current = 'safari'
    } else if (userAgent.match(/opr\//i)) {
      browser.current = 'opera'
    } else if (userAgent.match(/edg/i)) {
      browser.current = 'edge'
    }
  }, [])

  const incrementAppState = () => {
    setAppState(st => st + 1)
  }

  const determinePostsMetadata_old = (details, instanceVersion, availablePosts) => {
    const TOTAL_POSTS = availablePosts.length
    let postsMetadata = {}
    let peopleList = extend([...details.friends], TOTAL_POSTS)
    let authorsList = peopleList.map((value, index) => { return { ...value, index } })
    for (let p of availablePosts) {
      let i = Math.floor(Math.random() * authorsList.length)
      postsMetadata[p] = {
        initialLikeCount: 0,
        initialShareCount: 0,
        friendData: {},
        authorData: { ...authorsList[i] },
      }
      authorsList.splice(i, 1)
    }
    if (instanceVersion === 3 || instanceVersion === 4) {
      let countsArr1 = ['LL', 'LH', 'HL', 'HH']
      let countsArr2 = jumble(['LH', 'HL', 'HH'])
      let countsArr = jumble([...countsArr1, countsArr2[1], countsArr2[2]]) // Considering total posts = 6
      assert(countsArr.length === availablePosts.length)
      for (let i = 0; i < TOTAL_POSTS; i++) {
        let p = availablePosts[i]
        let counts = getAdCounts(countsArr[i])
        postsMetadata[p].initialLikeCount = counts.likersCount
        postsMetadata[p].initialShareCount = counts.sharersCount
      }
    }
    else if (instanceVersion === 5 || instanceVersion === 6) {
      let countsArr1 = ['LLF', 'LHF', 'HLF', 'HHF']
      let countsArr2 = jumble(['LL', 'LH', 'HL', 'HH'])
      let countsArr = jumble([...countsArr1, countsArr2[1], countsArr2[2]]) // Considering total posts = 7
      assert(countsArr.length === availablePosts.length)
      let friendsList = []
      if (details.friends.length >= countsArr1.length)
        friendsList = details.friends.map((value, index) => { return { ...value, index } })
      else
        friendsList = peopleList.map((value, index) => { return { ...value, index } })
      for (let i = 0; i < TOTAL_POSTS; i++) {
        let p = availablePosts[i]
        let counts = getAdCounts(countsArr[i])
        postsMetadata[p].initialLikeCount = counts.likersCount
        postsMetadata[p].initialShareCount = counts.sharersCount
        if (countsArr[i][2] === 'F') {
          let f = Math.floor(Math.random() * friendsList.length)
          if (friendsList[f].index === postsMetadata[p].authorData.index)
            f = (f + 2) % friendsList.length
          postsMetadata[p].friendData = { ...friendsList[f], type: 'liked' }
        }
      }
    }
    return postsMetadata
  }


  const determinePostsMetadata = (details, instanceVersion) => {


    // availablePosts will also be constant = 4 posts (app, non-product, restaurant/food subscription service? grocery?)
    let availablePosts = Array(4).fill(0)
      .map((_, idx) => idx)

    const TOTAL_POSTS = availablePosts.length
    let postsMetadata = {}
    let peopleList = extend([...details.friends], TOTAL_POSTS)

    // authorList will be replaced. Each post will carry its author information (name)
    // what i can do is to make a hook (useState) that carries author information




    //let authorsList = peopleList.map((value, index) => {return { ...value, index }})
    let authorsList = [
      { name: 'Time Blocking Planners', index: 0 },
      { name: 'Nature Coloring Books', index: 1 },
      { name: 'Cookie Recipes', index: 2 },
      { name: 'Habit Trackers', index: 3 }
    ]

    for (let p of availablePosts) {
      //let i = Math.floor(Math.random() * authorsList.length)

      postsMetadata[p] = {
        initialLikeCount: 0,
        initialShareCount: 0,
        friendData: {},
        authorData: { ...authorsList[p] },
      }
      //authorsList.splice(i, 1) //sllice deletes -- we don't need it 
    }

    if (instanceVersion === 300) { // use instanceVersion===300 to represent my 2023 Prolific experiment

      //let is_buynow = jumble(['Y','N'])[0] // Y: use "buy/install now" message. N: use "learn more" message
      //let like_count = jumble(['H','L'])[0]

      // is_buynow_array is an array of 4 elements (one for each post) that shows whether to use the buynow message (Y) or not (N)
      let is_buynow_array = Array(TOTAL_POSTS).fill(0)
        .map(() => (['Y', 'N'])[getRandomInt(2)])


      // is_ad_array is an array of 4 elements (one for each post) that shows whether to show 'sponsored'(Y) or timestamp (N)
      let is_ad_array = Array(TOTAL_POSTS).fill(0)
        .map(() => (['Y', 'N'])[getRandomInt(2)])


      // like_count_array is an array of 4 elements (one for each post) that shows the like count for each post
      // 'H'igh, 'L'ow, 'N'one
      let like_count_array = Array(TOTAL_POSTS).fill(0)
        .map(() => (['H', 'L', 'N'])[getRandomInt(3)])

      // friendlike_count_array is an array of 4 elements (one for each post) that shows the 
      // number of friend likes for each post; each post will have up to X-1 likes where X is from getRandonInt(X)
      let friendlike_count_array = Array(TOTAL_POSTS).fill(0)
        .map(() => getRandomInt(4))



      // create friendData
      let friendsList = []

      friendsList = details.friends.map((value, index) => { return { ...value, index } })



      // Now, assign each post a message, like_count, and friendlike_count

      for (let i = 0; i < TOTAL_POSTS; i++) {
        let p = availablePosts[i]  // i is 0,1,2,3; p is also 0, 1, 2, 3. i==p. 
        let like_counts = getLikeCounts(like_count_array[i])
        postsMetadata[p].initialLikeCount = like_counts.likersCount
        postsMetadata[p].initialFriendlikeCount = friendlike_count_array[p]
        postsMetadata[p].is_buynow_message = is_buynow_array[p]
        postsMetadata[p].is_ad = is_ad_array[p]


        // friend_like_count_array[i] shows how many friends like post.
        // need a function to randomly sample friend_like_count_array[i] friends from friendlist
        // approach: first, jumble the friendsList, then slice the first friend_like_count_array[i] elements
        let friends_that_like = jumble(friendsList).slice(0, friendlike_count_array[i])
        let friends_that_like_array = friends_that_like.map(a_friend => a_friend.name) // put liked friend names in an array
        postsMetadata[p].friendData = friends_that_like_array // this looks like ['Friend 1', 'Friend 2', 'Friend 3']
        //postsMetadata[p].friendData = { ...friends_that_like, type: 'liked' }



      }




    }



    return postsMetadata
  }











  /*
    const registerUser_old = async (prolificId, details) => {
      // details should contain:
      // name: string, prolificId: string, friends: Array of Objects [{ name: string }, ...]
      let userRef = db.collection('users').doc(prolificId)
      try {
        let fetchedData = await userRef.get()
        if (fetchedData.exists) {
          let { userCount, instanceVersion, postsOrder } = fetchedData.data()
          // if instanceVersion is odd: 1 / 3 / 5 then Politics posts: Ids 1...6
          // else if even: 2 / 4 / 6 then Covid posts: Ids 7...12
          const TOTAL_POSTS = 6
          let availablePosts = Array(TOTAL_POSTS).fill(0)
                                .map((_, idx) => idx + (instanceVersion%2 ? 1 : (TOTAL_POSTS+1)))
          let postsMetadata = determinePostsMetadata(details, instanceVersion, availablePosts)
          await userRef.update({
            ...details,
            postsMetadata,
            sessionStartTime: Timestamp.now(),
            sessionEndTime: FieldValue.delete(),
            uniqueCode: FieldValue.delete(),
            browser: browser.current,
          })
          setCurUser({
            ...details,
            userCount,
            instanceVersion,
            postsOrder,
            postsMetadata,
          })
          setTotalStates(_ => {
            if (fetchedData.data().instanceVersion % 2)
              return 2 * fetchedData.data().postsOrder.length + Object.keys(politicsQuestions).length + 1
            else
              return 2 * fetchedData.data().postsOrder.length + Object.keys(covidQuestions).length + 1
          })
        }
        else {
          // Upload new user details
          // 1. Get total user count
          let { docs } = await db.collection('userCount').get()
          let userCount = 0
          for (let d of docs) {
            userCount += Number.parseInt(d.data().count)
          }
          // 2. Calculate instance version to redirect the user
          const TOTAL_VERSIONS = 6
          let instanceVersion = (userCount % TOTAL_VERSIONS) + 1
          // 3. Determine random posts order for the user
          // and also the like & share counts, author and friend data for every post
          const TOTAL_POSTS = 6
          // if instanceVersion is odd: 1 / 3 / 5 then Politics posts: Ids 1...6
          // else if even: 2 / 4 / 6 then Covid posts: Ids 7...12
          let availablePosts = Array(TOTAL_POSTS).fill(0)
                                .map((_, idx) => idx + (instanceVersion%2 ? 1 : (TOTAL_POSTS+1)))
          
          
          
          
          let postsOrder = jumble([...availablePosts])
          let postsMetadata = determinePostsMetadata(details, instanceVersion, availablePosts)
          // 4. Upload details
          await userRef.set({
            ...details,
            userCount: userCount + 1,
            instanceVersion,
            postsOrder,
            postsMetadata,
            sessionStartTime: Timestamp.now(),
            browser: browser.current,
          })
          // 5. Increment user count
          let randomIdx = Math.floor(Math.random() * 5).toString()
          let counterRef = db.collection('userCount').doc(randomIdx)
          let counterExists = (await counterRef.get()).exists
          if (counterExists)
            await counterRef.update(({ count: FieldValue.increment(1) }))
          else
            await counterRef.set({ count: 1 })
          // 6. Set current user data
          setCurUser({
            ...details,
            userCount: userCount + 1,
            instanceVersion,
            postsOrder,
            postsMetadata,
          })
          // Set total number of states
          setTotalStates(_ => {
            if (instanceVersion % 2)
              return 2 * TOTAL_POSTS + Object.keys(politicsQuestions).length + 1
            else 
              return 2 * TOTAL_POSTS + Object.keys(covidQuestions).length + 1
          })
        }
      } catch (err) {
        throw err
      }
    }
  
  
  */

  const registerUser_fb_mock2 = async (prolificId, details) => {
    // details should contain:
    // name: string, prolificId: string, friends: Array of Objects [{ name: string }, ...]
    let userRef = db.collection('users').doc(prolificId)
    try {
      let fetchedData = await userRef.get()
      if (fetchedData.exists) {
        let { userCount, instanceVersion, postsOrder } = fetchedData.data()

        const TOTAL_POSTS = 4

        let postsMetadata = determinePostsMetadata(details, instanceVersion)
        await userRef.update({
          ...details,
          postsMetadata,
          sessionStartTime: Timestamp.now(),
          sessionEndTime: FieldValue.delete(),
          uniqueCode: FieldValue.delete(),
          browser: browser.current,
        })
        setCurUser({
          ...details,
          userCount,
          instanceVersion,
          postsOrder,
          postsMetadata,
        })
        setTotalStates(_ => {
          return 2 * fetchedData.data().postsOrder.length + Object.keys(demoQuestions).length + 1
        })
      }
      else {
        // Upload new user details
        // 1. Get total user count
        let { docs } = await db.collection('userCount').get()
        let userCount = 0
        for (let d of docs) {
          userCount += Number.parseInt(d.data().count)
        }
        // 2. set instance verison to 100

        let instanceVersion = 100

        // 3. Determine random posts order for the user
        // and also the like & share counts, author and friend data for every post
        const TOTAL_POSTS = 4


        let availablePosts = Array(4).fill(0)
          .map((_, idx) => idx)



        let postsOrder = jumble([...availablePosts])
        let postsMetadata = determinePostsMetadata(details, instanceVersion)

        // 4. Upload details
        await userRef.set({
          ...details,
          userCount: userCount + 1,
          instanceVersion,
          postsOrder,
          postsMetadata,
          sessionStartTime: Timestamp.now(),
          browser: browser.current,
        })
        // 5. Increment user count
        let randomIdx = Math.floor(Math.random() * 5).toString()
        let counterRef = db.collection('userCount').doc(randomIdx)
        let counterExists = (await counterRef.get()).exists
        if (counterExists)
          await counterRef.update(({ count: FieldValue.increment(1) }))
        else
          await counterRef.set({ count: 1 })
        // 6. Set current user data
        setCurUser({
          ...details,
          userCount: userCount + 1,
          instanceVersion,
          postsOrder,
          postsMetadata,
        })
        // Set total number of states (this is the total number of questions)
        // For ad: 4 ad posts, each has 1 post, 1 questions on the post -> 8 total
        // Then there is demographic questions (? questions total)
        // Therefore, total states (Qs) = 2*4 + ? demo questions + 1 (ending card)
        setTotalStates(_ => {
          return 2 * TOTAL_POSTS + Object.keys(demoQuestions).length + 1
        })
      }
    } catch (err) {
      throw err
    }

  }

  const registerUser = async (prolificId, details) => {
    // details should contain:
    // name: string, prolificId: string, friends: Array of Objects [{ name: string }, ...]
    let userRef = db.collection('users').doc(prolificId)
    try {
      let fetchedData = await userRef.get()
      if (fetchedData.exists) {
        let { userCount, instanceVersion, postsOrder } = fetchedData.data()

        const TOTAL_POSTS = 4

        let postsMetadata = determinePostsMetadata(details, instanceVersion)
        await userRef.update({
          ...details,
          postsMetadata,
          sessionStartTime: Timestamp.now(),
          sessionEndTime: FieldValue.delete(),
          uniqueCode: FieldValue.delete(),
          browser: browser.current,
        })
        setCurUser({
          ...details,
          userCount,
          instanceVersion,
          postsOrder,
          postsMetadata,
        })
        setTotalStates(_ => {
          return 2 * fetchedData.data().postsOrder.length + Object.keys(demoQuestions).length + 1
        })
      }
      else {
        // Upload new user details
        // 1. Get total user count
        let { docs } = await db.collection('userCount').get()
        let userCount = 0
        for (let d of docs) {
          userCount += Number.parseInt(d.data().count)
        }
        // 2. set fb-mock-4 instance verison to 300

        let instanceVersion = 300

        // 3. Determine random posts order for the user
        // and also the like & share counts, author and friend data for every post
        const TOTAL_POSTS = 4


        let availablePosts = Array(4).fill(0)
          .map((_, idx) => idx)



        let postsOrder = jumble([...availablePosts])
        let postsMetadata = determinePostsMetadata(details, instanceVersion)

        // 4. Upload details
        await userRef.set({
          ...details,
          userCount: userCount + 1,
          instanceVersion,
          postsOrder,
          postsMetadata,
          sessionStartTime: Timestamp.now(),
          browser: browser.current,
        })
        // 5. Increment user count
        let randomIdx = Math.floor(Math.random() * 5).toString()
        let counterRef = db.collection('userCount').doc(randomIdx)
        let counterExists = (await counterRef.get()).exists
        if (counterExists)
          await counterRef.update(({ count: FieldValue.increment(1) }))
        else
          await counterRef.set({ count: 1 })
        // 6. Set current user data
        setCurUser({
          ...details,
          userCount: userCount + 1,
          instanceVersion,
          postsOrder,
          postsMetadata,
        })
        // Set total number of states (this is the total number of questions)
        // For ad: 4 ad posts, each has 1 post, 1 questions on the post -> 8 total
        // Then there is demographic questions (? questions total)
        // Therefore, total states (Qs) = 2*4 + ? demo questions + 1 (ending card)
        setTotalStates(_ => {
          return 2 * TOTAL_POSTS + Object.keys(demoQuestions).length + 1
        })
      }
    } catch (err) {
      throw err
    }

  }









  const endSessionTime = async () => {
    let codeLength = 8
    let uniqueCode = `${Math.ceil(Math.random() * 9)}`
    for (let i = 1; i < codeLength; i++)
      uniqueCode += Math.floor(Math.random() * 10)
    uniqueCode = Number.parseInt(uniqueCode)
    let ref = db.collection('users').doc(curUser.prolificId)
    try {
      await ref.update({ sessionEndTime: Timestamp.now(), uniqueCode })
      return uniqueCode
    } catch (err) {
      throw err
    }
  }

  const loadPost = async (id) => {
    try {
      let post = POSTS[id]
      let metadata = curUser.postsMetadata[id]
      setPosts(prevPosts => {
        let friendData = metadata.friendData
        let is_buynow_message = metadata.is_buynow_message
        let is_ad = metadata.is_ad

        if (friendData.index)
          friendData.id = Array(20).fill(friendData.index).map((_, idx) => (friendData.index + idx)).join('')
        return {
          ...prevPosts,
          [id]: {
            ...post,
            authorData: {
              ...metadata.authorData,
              id: Array(20).fill(metadata.authorData.index).map((_, idx) => (metadata.authorData.index + idx)).join(''),
            },
            friendData,
            initialLikers: getFakeList(metadata.initialLikeCount),
            initialSharers: getFakeList(metadata.initialShareCount),
            is_buynow_message: is_buynow_message,
            is_ad: is_ad,
            likers: new Set(),
            sharers: new Set(),
            purchasers: new Set(),
          }
        }
      })
      // Start post time
      let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
      await ref.set({
        id: Number.parseInt(id),
        startTime: Timestamp.now(),
      })
    } catch (err) {
      throw err
    }
  }

  const endPostTime = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ endTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
    incrementAppState()
  }

  const likePost = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ likedTime: Timestamp.now() })
      setPosts(prevPosts => {
        let thisPost = prevPosts[id]
        thisPost.likers.add(curUser.prolificId)
        return { ...prevPosts, [id]: { ...thisPost } }
      })
    } catch (err) {
      throw err
    }
  }

  const unLikePost = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ likedTime: FieldValue.delete() })
      setPosts(prevPosts => {
        let thisPost = prevPosts[id]
        thisPost.likers.delete(curUser.prolificId)
        return { ...prevPosts, [id]: { ...thisPost } }
      })
    } catch (err) {
      throw err
    }
  }

  const sharePost = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ sharedTime: Timestamp.now() })
      setPosts(prevPosts => {
        let thisPost = prevPosts[id]
        thisPost.sharers.add(curUser.prolificId)
        return { ...prevPosts, [id]: { ...thisPost } }
      })
    } catch (err) {
      throw err
    }
  }

  const viewPost = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ viewedTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  // Record clicking time
  const clickButton = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ clickedTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }


  // Record purchase/install time
  const purchaseButton = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await ref.update({ purchasedTime: Timestamp.now() })
      setPosts(prevPosts => {
        let thisPost = prevPosts[id]
        thisPost.purchasers.add(curUser.prolificId)
        return { ...prevPosts, [id]: { ...thisPost } }
      })
    } catch (err) {
      throw err
    }
  }



  const clickOnAuthorProfile = async (id) => {
    // Add the time in user's doc
    let userRef = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await userRef.update({ clickOnAuthorProfileTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  const clickOnFriendProfile = async (id) => {
    // Add the time in user's doc
    let userRef = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await userRef.update({ clickOnFriendProfileTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  const clickOnSharersList = async (id) => {
    // Add the time in user's doc
    let userRef = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await userRef.update({ clickOnSharersListTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  const clickOnLikersList = async (id) => {
    // Add the time in user's doc
    let userRef = db.collection('users').doc(curUser.prolificId).collection('postResponses').doc(`post${id}`)
    try {
      await userRef.update({ clickOnLikersListTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  const startPostQuestionTime = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postQuestionResponses').doc(`postQuestion${id}`)
    try {
      await ref.set({
        id: Number.parseInt(id),
        startTime: Timestamp.now(),
      })
    } catch (err) {
      throw err
    }
  }

  const receivePostQuestionResponses = async (id, responses) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postQuestionResponses').doc(`postQuestion${id}`)
    try {
      await ref.update({ responses, endTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
    incrementAppState()
  }





  const viewPostInQuestions = async (id) => {
    let ref = db.collection('users').doc(curUser.prolificId).collection('postQuestionResponses').doc(`postQuestion${id}`)
    try {
      await ref.update({ clickOnReadMoreTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
  }

  const startQuestionTime = async (id) => {
    //let category = (curUser.instanceVersion % 2) ? 'politicsQuestion' : 'covidQuestion'
    let category = 'demoQuestion'

    let ref = db.collection('users').doc(curUser.prolificId).collection('questionResponses').doc(`${category}${id}`)
    try {
      await ref.set({
        category,
        id: Number.parseInt(id),
        startTime: Timestamp.now(),
      })
    } catch (err) {
      throw err
    }
  }

  const receiveQuestionResponses = async (id, responses) => {
    //let str = (curUser.instanceVersion % 2) ? `politicsQuestion${id}` : `covidQuestion${id}`
    let str = `demoQuestion${id}`
    let ref = db.collection('users').doc(curUser.prolificId).collection('questionResponses').doc(str)
    try {
      await ref.update({ responses, endTime: Timestamp.now() })
    } catch (err) {
      throw err
    }
    incrementAppState()
  }

  // const [currentUserData, setCurrentUserData] = useState(null)
  // const [posts, setPosts] = useState([])
  // const [profiles, setProfiles] = useState({})
  // const [loadingPosts, setLoadingPosts] = useState(false)
  // const postsCollectionRef = useRef(null)
  // const nextPostIndex = useRef(0)
  // const loadingMorePosts = useRef(false)

  // useEffect(() => {
  //   // Set posts collection's reference
  //   postsCollectionRef.current = db.collection('posts')
  // }, [])

  // const checkCurrentUserData = async (prolificId, userDetails) => {
  //   // userDetails should contain:
  //   // name, prolificId, friends

  //   try {
  //     var ref = db.collection('users').doc(prolificId)
  //     var fetchedData = await ref.get()

  //     if (fetchedData.exists) {
  //       await ref.update(userDetails)
  //       setCurrentUserData({
  //         ...userDetails,
  //         userCount: fetchedData.data().userCount,
  //         instanceVersion: fetchedData.data().instanceVersion,
  //         postsOrder: fetchedData.data().postsOrder
  //       })
  //     }
  //     else {
  //       // Upload new user's details

  //       // 1. Get total user count
  //       let { docs } = await db.collection('userCount').get()
  //       let userCount = 0
  //       for (let d of docs) {
  //         userCount += d.data().count
  //       }
  //       userCount = Number.parseInt(userCount)

  //       // 2. Calculate instanceVersion
  //       // Version can be:
  //       //   1: nothing to be shown
  //       //   2: only counts of shares, likes to be shown
  //       //   3: in addition to counts, friend's activity also to be shown
  //       // const TOTAL_VERSIONS = 3
  //       let instanceVersion = 2  // (userCount % TOTAL_VERSIONS) + 1

  //       // 3. Determine random posts order for the user
  //       const TOTAL_POSTS = 12
  //       let availablePosts = Array(TOTAL_POSTS).fill().map((_, idx) => 1 + idx)
  //       let postsOrder = []
  //       while (availablePosts.length) {
  //         let idx = Math.floor(Math.random() * availablePosts.length)
  //         postsOrder.push(availablePosts[idx])
  //         availablePosts.splice(idx, 1)
  //       }

  //       // 4. Upload details
  //       await ref.set({
  //         ...userDetails,
  //         userCount: userCount + 1,
  //         instanceVersion,
  //         postsOrder,
  //         createdAt: Timestamp.now()
  //       })

  //       // 5. Increment user count
  //       let randomIndex = Math.floor(Math.random() * 5).toString()
  //       let counterRef = db.collection('userCount').doc(randomIndex)
  //       let counterExists = (await counterRef.get()).exists
  //       if (counterExists)
  //         await counterRef.update({ count: FieldValue.increment(1) })
  //       else
  //         await counterRef.set({ count: 1 })

  //       // Set current user data
  //       setCurrentUserData({
  //         ...userDetails,
  //         userCount: userCount + 1,
  //         instanceVersion,
  //         postsOrder
  //       })
  //     }
  //   }
  //   catch (err) {
  //     throw err
  //   }

  //   // // Update profiles state variable
  //   // setProfiles(prevProfiles => ({
  //   //   ...prevProfiles,
  //   //   [prolificId]: userDetails
  //   // }))
  // }

  // const loadProfile = async (userId) => {
  //   try {
  //     var userData = (await db.collection('users').doc(userId).get()).data()

  //     if (!userData) {
  //       console.log('User data not available')
  //       return
  //     }
  //   }
  //   catch (err) {
  //     console.log('Error loading profile details of user id:', userId)
  //     throw err
  //   }

  //   if (userData.fake === true) {
  //     // Decide the name of the fake user
  //     let namesList = userData.names
  //     let myList = [currentUserData.name, ...currentUserData.friends]
  //     userData.name = decideName(namesList, myList)
  //     delete userData.names
  //   }

  //   setProfiles(prevProfiles => ({
  //     ...prevProfiles,
  //     [userId]: { ...userData }
  //   }))
  // }

  // const sharePost = async (postId, friendData) => {
  //   // friendData should contain:
  //   // {name: '...', prolificId: '...', type: 'shared'/'liked'} or an empty object {}

  //   try {
  //     // Add a 'shared' event for the post
  //     await postsCollectionRef.current.doc(`${postId}`).collection('events')
  //       .add({
  //         type: 'shared',
  //         postId,
  //         prolificId: currentUserData.prolificId,
  //         name: currentUserData.name,
  //         friendActivity: friendData,
  //         timestamp: Timestamp.now()
  //       })
  //   }
  //   catch (err) {
  //     console.log('Error sharing post', err.name, err.message)
  //     throw err
  //   }

  //   // Update sharers set of the post in posts state variable
  //   setPosts(prevPosts => {
  //     let idx = prevPosts.findIndex(post => post.postId === postId)
  //     prevPosts[idx].sharers.add(currentUserData.prolificId)
  //     return [...prevPosts]
  //   })
  // }

  // const viewPost = async (postId, friendData) => {
  //   // friendData should contain:
  //   // {name: '...', prolificId: '...', type: 'shared'/'liked'} or an empty object {}

  //   try {
  //     var eventsRef = postsCollectionRef.current.doc(`${postId}`).collection('events')

  //     // Get the list of views of the post by current user
  //     var { docs } = await eventsRef.where('type', '==', 'viewed').where('prolificId', '==', currentUserData.prolificId).get()

  //     if (docs.length > 0) // User had viewed the post earlier
  //       return

  //     // Add a view event for the post
  //     await eventsRef.add({
  //       type: 'viewed',
  //       postId,
  //       prolificId: currentUserData.prolificId,
  //       name: currentUserData.name,
  //       friendActivity: friendData,
  //       timestamp: Timestamp.now()
  //     })
  //   }
  //   catch (err) {
  //     console.log('Error incrementing view for the post', err.name, err.message)
  //     throw err
  //   }

  //   // // Update viewers set of the post in posts state variable
  //   // setPosts(prevPosts => {
  //   //   let idx = prevPosts.findIndex(post => post.postId === postId)
  //   //   prevPosts[idx].viewers.add(currentUserData.prolificId)
  //   //   return [...prevPosts]
  //   // })
  // }

  // const toggleLikePost = async (postId, action, friendData) => {
  //   // action should be 'like' or 'unlike'
  //   // friendData should contain:
  //   // {name: '...', prolificId: '...', type: 'shared'/'liked'} or an empty object {}

  //   try {
  //     var eventsRef = postsCollectionRef.current.doc(`${postId}`).collection('events')

  //     if (action === 'like') {
  //       // Add a like event to firestore
  //       await eventsRef.add({
  //         type: 'liked',
  //         postId,
  //         prolificId: currentUserData.prolificId,
  //         name: currentUserData.name,
  //         friendActivity: friendData,
  //         timestamp: Timestamp.now()
  //       })
  //     }

  //     else if (action === 'unlike') {
  //       let { docs } = await eventsRef.where('type', '==', 'liked').where('prolificId', '==', currentUserData.prolificId).get()
  //       for (let d of docs) {
  //         await eventsRef.doc(d.id).delete()
  //       }
  //     }
  //   }
  //   catch (err) {
  //     console.log('Error toggling like for the post', err.name, err.message)
  //     throw err
  //   }

  //   // Update likers set of the post in posts state variable
  //   setPosts(prevPosts => {
  //     let idx = prevPosts.findIndex(post => post.postId === postId)
  //     if (action === 'like') prevPosts[idx].likers.add(currentUserData.prolificId)
  //     else if (action === 'unlike') prevPosts[idx].likers.delete(currentUserData.prolificId)
  //     return [...prevPosts]
  //   })
  // }

  // const loadPost = async (postId) => {
  //   try {
  //     // Load post data
  //     var postData = (await postsCollectionRef.current.doc(`${postId}`).get()).data()
  //     var newPostObj = { ...postData, createdAt: new Date(postData.createdAt.seconds) }

  //     // Load author's data
  //     if (!profiles[postData.creator])
  //       await loadProfile(postData.creator)

  //     // Load likers and sharers from 'events' sub-collection
  //     var eventsRef = postsCollectionRef.current.doc(`${postId}`).collection('events')
  //     var docs

  //     if (currentUserData.instanceVersion === 3) {
  //       // Load like and share events by all users
  //       docs = (await eventsRef.where('type', 'in', ['liked', 'shared']).get()).docs
  //     }
  //     else {
  //       // Load like and share events by current user only
  //       docs = (await eventsRef.where('type', 'in', ['liked', 'shared']).where('prolificId', '==', currentUserData.prolificId).get()).docs
  //     }

  //     setProfiles(prevProfiles => {
  //       let obj = {}
  //       for (let doc of docs) {
  //         obj[doc.data().prolificId] = { name: doc.data().name, prolificId: doc.data().prolificId }
  //       }
  //       return { ...prevProfiles, ...obj }
  //     })

  //     newPostObj.likers = new Set(docs.filter(doc => doc.data().type === 'liked').map(doc => doc.data().prolificId))
  //     newPostObj.sharers = new Set(docs.filter(doc => doc.data().type === 'shared').map(doc => doc.data().prolificId))

  //     setPosts(prevPosts => {
  //       let idx = prevPosts.findIndex(post => post.postId === newPostObj.postId)
  //       if (idx > -1) {
  //         let postsCopy = [...prevPosts]
  //         postsCopy[idx] = newPostObj
  //         return postsCopy
  //       }
  //       return [...prevPosts, newPostObj]
  //     })
  //   }
  //   catch (err) {
  //     console.log('Error while loading post with Post Id:', postId)
  //     throw err
  //   }
  // }

  // const loadPosts = async () => {
  //   if (loadingMorePosts.current === true) {
  //     return
  //   }

  //   try {
  //     setLoadingPosts(true)
  //     loadingMorePosts.current = true

  //     var { postsOrder } = currentUserData
  //     let numberOfPostsOnce = 3
  //     let idx = nextPostIndex.current

  //     if (idx >= postsOrder.length) {
  //       return
  //     }

  //     for (var i = idx; (i < postsOrder.length && i < idx + numberOfPostsOnce); i++) {
  //       await loadPost(postsOrder[i])
  //     }

  //     nextPostIndex.current = i
  //   }
  //   catch (err) {
  //     console.log('Couldn\'t load posts')
  //     throw err
  //   }
  //   finally {
  //     setLoadingPosts(false)
  //     loadingMorePosts.current = false
  //   }
  // }

  return (
    <AdDatabaseContext.Provider value={{
      posts, adPostQuestions, demoQuestions,
      //politicsQuestions, covidQuestions,
      curUser, registerUser, endSessionTime,
      appState, totalStates, incrementAppState,
      loadPost, endPostTime, viewPost, likePost, unLikePost, sharePost,
      clickButton, purchaseButton,
      clickOnAuthorProfile, clickOnFriendProfile, clickOnSharersList, clickOnLikersList,
      startPostQuestionTime, receivePostQuestionResponses, viewPostInQuestions,
      startQuestionTime, receiveQuestionResponses,
    }}>
      {children}
    </AdDatabaseContext.Provider>
  )
}
